import { Route } from '@angular/router';
import { Path } from '../../../common/constants/paths.constant';
import { receivedRfpDetailsResolver } from '../../../common/resolvers/received-rfp.resolver';
import { quotationRFPDetailsResolver } from '../../../common/resolvers/quotation-rfp-details.resolver';
import { rfpContractDetailsResolver } from '../../../common/resolvers/rfp-contract-details.resolver';

export const contractorRoutes: Route[] = [
  {
    path: '',
    redirectTo: `/${localStorage.getItem('lang') ?? 'ar'}/${Path.CONTRACTOR}/${Path.DASHBOARD}`,
    pathMatch: 'full',
  },
  {
    path: Path.DASHBOARD,
    loadComponent: () =>
      import('./dashboard/dashboard.component').then(c => c.DashboardComponent),
  },
  {
    path: Path.RECEIVED_RFP.RECEIVED_RFP,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./received-rfp/received-rfp-board.component').then(
            c => c.ReceivedRfpBoardComponent
          ),
      },
      {
        path: `${Path.RECEIVED_RFP.DETAILS}/:rfpId`,
        loadComponent: () =>
          import('./received-rfp/received-rfp-details/received-rfp-details.component').then(
            c => c.ReceivedRfpDetailsComponent
          ),
        resolve: {
          rfpDetails: receivedRfpDetailsResolver,
        },
      },
    ],
  },
  {
    path: Path.QUOTATION.QUOTATION_RFP,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('../../../pages/dashboard/contractor/quotations/quotations.component').then(
            C => C.QuotationsComponent
          ),
      },
      {
        path: `${Path.QUOTATION.DETAILS}/:rfpId/:quotationId`,
        loadComponent: () =>
          import('../../../pages/dashboard/contractor/quotations/quotation-details-view/quotation-details-view.component').then(
            c => c.QuotationDetailsViewComponent
          ),
        resolve: {
          data: quotationRFPDetailsResolver,
        },
      },
    ],
  },
  // The legacy RFP purchase-orders route ('po-rfp') and its screens/service/
  // resolver have been removed entirely — RFP Contracting (Path.CONTRACT)
  // replaces it.
  {
    path: Path.CONTRACT.CONTRACT,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('../../../pages/dashboard/contractor/rfp-contract/rfp-contract-board.component').then(
            c => c.RfpContractBoardComponent
          ),
      },
      {
        path: `${Path.CONTRACT.DETAILS}/:contractId`,
        loadComponent: () =>
          import('./rfp-contract/rfp-contract-show/rfp-contract-show.component').then(
            c => c.RfpContractShowComponent
          ),
        resolve: {
          contractDetails: rfpContractDetailsResolver,
        },
      },
    ],
  },
  {
    path: Path.ACCOUNT,
    loadComponent: () =>
      import('./account/account.component').then(c => c.AccountComponent),
  },
  {
    path: Path.MY_SERVICES,
    loadComponent: () =>
      import('./my-services/my-services.component').then(
        c => c.MyServicesComponent
      ),
  },
];
